import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromIndexReducer from '../reducers';
import * as fromCheckCardStatusReducer from '../reducers/check-card-status.reducer';

export const getCheckCardStatusResponse = createSelector(
  fromIndexReducer.getCheckCardStatusState,
  fromCheckCardStatusReducer.getCheckCardStatusResponse
);
